<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
                 <router-link
      :to="
        '/CompanySalesReportPrint?' +
          'from=' +
          date_from +
          '&to=' +
          date_to 
      "
      target="_blank"
    >
      <v-icon>print</v-icon>
    </router-link>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u>
                تقرير شامل للشركة بتاريخ من {{ date_from }} الي تاريخ
                {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>
        <!-- <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_item"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    label="أختر الصنف"
                    persistent-hint
                    return-object
                    single-line
                   
                ></v-select>
                  </v-flex>  -->

        <v-flex xs12 sm6 md4>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="CompanySalesReport">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>
      <v-layout>
        <v-flex xs12 sm12 md12>المبيعات</v-flex>
        <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total }}</v-flex
        >
        <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count }}</v-flex
        >
      </v-layout>

      <v-data-table
        :headers="headers1"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog1"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem1(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers11"
                    :items="item_detail1.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.code }}</td>
                      <td>{{ props.item.discount }}</td>
                      <td>{{ props.item.price_before }}</td>
                      <td>{{ props.item.price_after }}</td>
                      <td>{{ props.item.created_at }}</td>
                      <td>
                        <v-dialog
                          v-model="detail_dialog12"
                          width="800"
                          style="padding:10px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              class="ml-4"
                              v-on="on"
                              @click="detailItem12(props.item)"
                            >
                              book
                            </v-icon>
                          </template>

                          <v-card>
                            <v-card-title
                              class="headline orange lighten-2"
                              primary-title
                            >
                              تفاصيل الفاتورة
                            </v-card-title>

                            <v-card-text>
                              <v-data-table
                                :headers="headers111"
                                :items="item_detail12.fatwora_items"
                                class="elevation-1"
                                :rows-per-page-items="rowsPerPageItems"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.item_name }}</td>
                                  <td>{{ props.item.item_num_after }}</td>
                                  <td>{{ props.item.final_price }}</td>
                                  <td>{{ props.item.item_discount }}</td>
                                  <td>{{ props.item.item_bonus }}</td>
                                </template>
                              </v-data-table>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="detail_dialog12 = false"
                              >
                                موافق
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog1 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مبيعات</div>

      <v-layout>
        <v-flex xs12 sm12 md12> مرتجع المبيعات </v-flex>
        <v-flex v-if="fatworas2.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total2 }}</v-flex
        >
        <v-flex v-if="fatworas2.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count2 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers2"
        :items="fatworas2"
        class="elevation-1"
        v-if="fatworas2.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog2"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem2(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers22"
                    :items="item_detail2.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.code }}</td>
                      <td>{{ props.item.manual_code }}</td>
                      <td>{{ props.item.reback_discount }}</td>
                      <td>{{ props.item.price_before }}</td>
                      <td>{{ props.item.price_after }}</td>
                      <td>
                        <v-dialog
                          v-model="detail_dialog22"
                          width="800"
                          style="padding:10px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              class="ml-4"
                              v-on="on"
                              @click="detailItem22(props.item)"
                            >
                              book
                            </v-icon>
                          </template>

                          <v-card>
                            <v-card-title
                              class="headline orange lighten-2"
                              primary-title
                            >
                              تفاصيل الفاتورة
                            </v-card-title>

                            <v-card-text>
                              <v-data-table
                                :headers="headers222"
                                :items="item_detail22.fatwora_items"
                                class="elevation-1"
                                :rows-per-page-items="rowsPerPageItems"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.item_name }}</td>
                                  <td>{{ props.item.item_num_before }}</td>
                                  <td>{{ props.item.item_num_reback }}</td>
                                  <td>{{ props.item.item_num_remain }}</td>
                                  <td>{{ props.item.price }}</td>
                                  <td>{{ props.item.total_price }}</td>
                                </template>
                              </v-data-table>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="detail_dialog22 = false"
                              >
                                موافق
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog2 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مرتجع مبيعات</div>
      <v-layout>
        <v-flex xs12 sm12 md12> المشتريات </v-flex>
        <v-flex v-if="fatworas3.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total3 }}</v-flex
        >
        <v-flex v-if="fatworas3.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count3 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers3"
        :items="fatworas3"
        class="elevation-1"
        v-if="fatworas3.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog3"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem3(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers33"
                    :items="item_detail3.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.code }}</td>
                      <td>{{ props.item.paper_code }}</td>
                      <td>{{ props.item.price }}</td>
                      <td>{{ props.item.fatwora_dicount }}</td>
                      <td>{{ props.item.final_price }}</td>
                      <td>
                        <v-dialog
                          v-model="detail_dialog32"
                          width="800"
                          style="padding:10px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              class="ml-4"
                              v-on="on"
                              @click="detailItem32(props.item)"
                            >
                              book
                            </v-icon>
                          </template>

                          <v-card>
                            <v-card-title
                              class="headline orange lighten-2"
                              primary-title
                            >
                              تفاصيل الفاتورة
                            </v-card-title>

                            <v-card-text>
                              <v-data-table
                                :headers="headers333"
                                :items="item_detail32.fatwora_items"
                                class="elevation-1"
                                :rows-per-page-items="rowsPerPageItems"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.item_name }}</td>
                                  <td>{{ props.item.item_num }}</td>
                                  <td>{{ props.item.price }}</td>
                                  <td>{{ props.item.total_price }}</td>
                                </template>
                              </v-data-table>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="detail_dialog32 = false"
                              >
                                موافق
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog3 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مشتريات</div>

      <v-layout>
        <v-flex xs12 sm12 md12> مرتجع المشتريات </v-flex>
        <v-flex v-if="fatworas4.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total4 }}</v-flex
        >
        <v-flex v-if="fatworas4.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count4 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers4"
        :items="fatworas4"
        class="elevation-1"
        v-if="fatworas4.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog4"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem4(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers44"
                    :items="item_detail4.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.code }}</td>
                      <td class="text-xs-right">
                        {{ props.item.final_price }}
                      </td>
                      <td>
                        <v-dialog
                          v-model="detail_dialog42"
                          width="800"
                          style="padding:10px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              class="ml-4"
                              v-on="on"
                              @click="detailItem42(props.item)"
                            >
                              book
                            </v-icon>
                          </template>

                          <v-card>
                            <v-card-title
                              class="headline orange lighten-2"
                              primary-title
                            >
                              تفاصيل الفاتورة
                            </v-card-title>

                            <v-card-text>
                              <v-data-table
                                :headers="headers444"
                                :items="item_detail42.fatwora_items"
                                class="elevation-1"
                                :rows-per-page-items="rowsPerPageItems"
                              >
                                <template slot="items" slot-scope="props">
                                  <td>{{ props.item.item_name }}</td>
                                  <td>{{ props.item.item_num }}</td>
                                  <td>{{ props.item.item_num_reback }}</td>
                                  <td>{{ props.item.item_num_remain }}</td>
                                  <td>{{ props.item.price }}</td>
                                  <td>{{ props.item.total_reback_price }}</td>
                                </template>
                              </v-data-table>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                flat
                                @click="detail_dialog42 = false"
                              >
                                موافق
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog4 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مرتجع مشتريات</div>

      <v-layout>
        <v-flex xs12 sm12 md12> المصروفات </v-flex>
        <v-flex v-if="fatworas5.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total5 }}</v-flex
        >
        <v-flex v-if="fatworas5.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count5 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers5"
        :items="fatworas5"
        class="elevation-1"
        v-if="fatworas5.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.money_q }}</td>
          <td class="text-xs-right">{{ props.item.money.name }}</td>
          <td class="text-xs-right">{{ props.item.emp_responsible_name }}</td>
          <td class="text-xs-right">{{ props.item.emp_name_to }}</td>
          <td class="text-xs-right">{{ props.item.notes }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير مصروفات</div>

      <v-layout>
        <v-flex xs12 sm12 md12> سداد العملاء</v-flex>
        <v-flex v-if="fatworas6.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total6 }}</v-flex
        >
        <v-flex v-if="fatworas6.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count6 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers1"
        :items="fatworas6"
        class="elevation-1"
        v-if="fatworas6.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog6"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem6(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers66"
                    :items="item_detail6.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.money_q }}</td>
                      <td>
                        {{ props.item.khazna ? props.item.khazna.name : "" }}
                      </td>
                      <td>{{ props.item.note }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog6 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير سدادات</div>
         <v-layout v-if="fatworas7.length > 0">
        <v-flex xs12 sm12 md12> خصومات العملاء</v-flex>
        <v-flex v-if="fatworas7.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ all_of_total7 }}</v-flex
        >
        <v-flex v-if="fatworas7.length > 0" xs12 sm6 md4
          ><b>مجموع الفواتير : </b> {{ count_of_count7 }}</v-flex
        >
      </v-layout>
      <v-data-table
        :headers="headers1"
        :items="fatworas7"
        class="elevation-1"
        v-if="fatworas7.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.total }}</td>
          <td>
            <v-dialog
              v-model="detail_dialog7"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem7(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  الفواتير
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers77"
                    :items="item_detail7.all"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.money_q }}</td>
                      <td>
                        {{ props.item.khazna ? props.item.khazna.name : "" }}
                      </td>
                      <td>{{ props.item.note }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog7 = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير خصومات</div>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  branches,
  khazina,
  khazna_fatworas,
  CompanySalesReport
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [1111400, 1111800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers1: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers11: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "خصم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر قبل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر بعد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers111: [
      {
        text: "الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر النهائي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "البونص",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers2: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers22: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الكود اليدوي",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "الخصم المسترجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر قبل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر بعد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers222: [
      {
        text: "الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد قبل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد المرتجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد المتبقي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers3: [
      {
        text: " كود المورد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم المورد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers33: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الكود الورقي",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخصم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر النهائي ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers333: [
      {
        text: " اسم الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers4: [
      {
        text: " كود المورد",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم المورد",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers44: [
      {
        text: " كود",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers444: [
      {
        text: " الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد الاصلي",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد المرتجع",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المتبقي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers5: [
      {
        text: " كود ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المبلغ",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "نوع المصروف ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "المستلم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الملاحظات",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers55: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع المتبقي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers555: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع المتبقي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers6: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التفاصيل ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers66: [
      {
        text: "المبلغ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الخزينة ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "الملاحظات",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers666: [
      {
        text: " كود العميل",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم العميل",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " عدد الفواتير  ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع الفواتير ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " مجموع المتبقي ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_branch: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    fatworas2: [],
    fatworas3: [],
    fatworas4: [],
    fatworas5: [],
    fatworas6: [],
    fatworas7: [],
    branches: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail1: {},
    item_detail12: {},
    item_detail2: {},
    item_detail22: {},
    item_detail3: {},
    item_detail32: {},
    item_detail4: {},
    item_detail42: {},
    item_detail5: {},
    item_detail52: {},
    item_detail6: {},
    item_detail62: {},
    detail_dialog1: false,
    detail_dialog12: false,
    detail_dialog2: false,
    detail_dialog22: false,
    detail_dialog3: false,
    detail_dialog32: false,
    detail_dialog4: false,
    detail_dialog42: false,
    detail_dialog5: false,
    detail_dialog52: false,
    detail_dialog6: false,
    detail_dialog62: false,
    all_of_total: 0,
    count_of_count: 0,
    all_of_total2: 0,
    count_of_count2: 0,
    all_of_total3: 0,
    count_of_count3: 0,
    all_of_total4: 0,
    count_of_count4: 0,
    all_of_total5: 0,
    count_of_count5: 0,
    all_of_total6: 0,
    count_of_count6: 0,
    count_of_count7: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem1(order) {
      this.item_detail1 = order;
    },
    detailItem12(order) {
      this.item_detail12 = order;
    },
    detailItem2(order) {
      this.item_detail2 = order;
    },
    detailItem22(order) {
      this.item_detail22 = order;
    },
    detailItem3(order) {
      this.item_detail3 = order;
    },
    detailItem32(order) {
      this.item_detail32 = order;
    },
    detailItem4(order) {
      this.item_detail4 = order;
    },
    detailItem42(order) {
      this.item_detail42 = order;
    },
    detailItem5(order) {
      this.item_detail5 = order;
    },
    detailItem52(order) {
      this.item_detail52 = order;
    },
    detailItem6(order) {
      this.item_detail6 = order;
    },
    detailItem62(order) {
      this.item_detail62 = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    CompanySalesReport() {
      var frmData = new FormData();
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      CompanySalesReport(frmData).then(response => {
        response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        response.data.myarr2.length > 0
          ? (this.fatworas2 = response.data.myarr2)
          : (this.fatworas2 = []);
        response.data.myarr3.length > 0
          ? (this.fatworas3 = response.data.myarr3)
          : (this.fatworas3 = []);
        response.data.myarr4.length > 0
          ? (this.fatworas4 = response.data.myarr4)
          : (this.fatworas4 = []);
        response.data.myarr5.length > 0
          ? (this.fatworas5 = response.data.myarr5)
          : (this.fatworas5 = []);
        response.data.myarr6.length > 0
          ? (this.fatworas6 = response.data.myarr6)
          : (this.fatworas6 = []);
           response.data.myarr7.length > 0
          ? (this.fatworas7 = response.data.myarr7)
          : (this.fatworas7 = []);
        this.all_of_total = response.data.all_of_total;
        this.count_of_count = response.data.count_of_count;
        this.all_of_total2 = response.data.all_of_total2;
        this.count_of_count2 = response.data.count_of_count2;
        this.all_of_total3 = response.data.all_of_total3;
        this.count_of_count3 = response.data.count_of_count3;
        this.all_of_total4 = response.data.all_of_total4;
        this.count_of_count4 = response.data.count_of_count4;
        this.all_of_total5 = response.data.all_of_total5;
        this.count_of_count5 = response.data.count_of_count5;
        this.all_of_total6 = response.data.all_of_total6;
        this.count_of_count6 = response.data.count_of_count6;
        this.count_of_count7 = response.data.count_of_count7;
      });
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-icon.ml-4.v-icon--link.material-icons.theme--dark {
  font-size: 25px !important;
}
</style>
